import { defineComponent as _defineComponent } from 'vue'

import { ProfileType } from '@/@types/graphql-types';

function ensureH1Tags(html: string | null | undefined): string {
	if (!html) return '';
	if (/<h1[\s>]/i.test(html)) return html;
	return `<h1>${html}</h1>`;
}

import { useAppStore, useLanguageStore } from '@/helpers/composables/useStores';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useArticle } from '@/features/editorial/composables/useArticle';
import { BuyboxParam, OfferLocation } from '@/helpers/offer-helper';

import { useEditorialTracking } from '@/features/editorial/tracking';

import AuthorBox from '@/features/editorial/components/AuthorBox.vue';
import ListArticle from '@/features/editorial/components/ListArticle.vue';
import NewsArticle from '@/features/editorial/components/NewsArticle.vue';
import PictureComp from '@/components/picture/PictureComp.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { SnowplowPackageContext, SnowplowTitleContextGraphql } from '@/helpers/tracking/providers/snowplow-contexts';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'EditorialArticle',
  setup(__props) {

const { country } = useLanguageStore();
const { article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading } =
	useArticle();

const { trackEditorial } = useEditorialTracking();

const { xServeTrack } = useAppStore();

const offerClickoutUrl = computed(() => {
	if (mainObject.value?.__typename === 'GenericTitleList' || !mainObject.value?.watchNowOffer) return null;

	const offer = mainObject.value.watchNowOffer;

	return new ClickoutUrl(offer)
		.addContexts(new SnowplowTitleContextGraphql(mainObject.value.objectId, mainObject.value.objectType))
		.addContexts(new SnowplowPackageContext(offer.package.packageId, offer.package.technicalName))
		.setForTracking('offerLocation', OfferLocation.PROMOTED_BUYBOX)
		.set('uct_country', country.value)
		.set('uct_buybox', BuyboxParam.Normal)
		.updateContext('TitleContextGraphql', 'jwRawEntityId', mainObject.value.id)
		.setCanary(xServeTrack.value);
});

return { __sfc: true,ensureH1Tags, country, article, author, mainObject, listEvents, publishDate, updatedDate, backdrop, isUpdated, isLoading, trackEditorial, xServeTrack, offerClickoutUrl, ProfileType, AuthorBox, ListArticle, NewsArticle, PictureComp, ProviderIcon }
}

})